import { Sun, Info } from "lucide-react";
import { Tooltip } from 'react-tooltip';
import { formatNumber } from '@/utils/formatNumber';
import { IconTitle } from '@/components/ui/icon-title';

interface SolarCardProps {
  ratio?: number | null;
  solarSurplus?: number | null;
  irradiance?: number | null;
}

export function SolarCard({ ratio, solarSurplus, irradiance }: SolarCardProps) {
  return (
    <div className="bg-white rounded-[10px] shadow-card p-2 border border-light-grey gap-1.5 flex flex-col h-fit">
      <div className="flex items-center justify-between">
        <IconTitle icon={Sun} title="Solar Surplus Rate" />
        <div className="flex items-center gap-2">
          <span className="heading-6">{formatNumber(ratio)}</span>
          <span className="paragraph-12">%</span>
        </div>
      </div>
      <div className="flex gap-1.5">
        <div className="flex flex-col grow p-1 bg-bg rounded-md border border-light-grey justify-between gap-2">
          <div className="flex items-center gap-1">
            <span className="paragraph-11 text-dark">Solar Surplus</span>
            <div
              data-tooltip-id="solar-surplus-tooltip"
              data-tooltip-place="right"
              className="cursor-pointer text-gray-400 hover:text-gray-600 flex"
            >
              <Info className="inline-block h-[10px] w-[10px] text-primary" />
            </div>
            <Tooltip arrowColor='bg-white' id="solar-surplus-tooltip" opacity={1} style={{
              backgroundColor: 'white',
              padding: '4px 6px',
              gap: '8px',
              width: "240px",
              boxShadow: "-4px -4px 20px 0px #7090B03D",
              backdropFilter: "blur(20px)",
            }}>
              <p className='paragraph-9 text-dark-blue'>Solar Surplus = Expected Active Power - Total Power Consumption</p>
              <p className='paragraph-9 text-dark-blue mt-1'>Expected Active Power = IRR × DC Input (999.6 kW) × PR Ratio (0.8)</p>
            </Tooltip>
          </div>
          <div className="flex items-baseline gap-2 text-black">
            <span className="heading-6">{formatNumber(solarSurplus)}</span>
            <span className="paragraph-12">kW</span>
          </div>
        </div>
        <div className="flex flex-col grow p-1 bg-bg rounded-md border border-light-grey justify-between gap-2">
          <span className="paragraph-11 text-dark">Irradiance</span>
          <div className="flex items-baseline gap-2 text-black">
            <span className="heading-6">{formatNumber(irradiance)}</span>
            <span className="paragraph-12">W/m<sup>2</sup></span>
          </div>
        </div>
      </div>
    </div>
  );
}